import { combineReducers } from "redux";
import havainnotReducer from '../havainnot/store/reducers'

const appReducer = combineReducers({
    havainnot: havainnotReducer,

});

const createRootReducer = () => {
    return (state: any, action: any) => {

        if (action.type === "RELOAD_APP") {
            state = {
                havainnot: {
                    authentication: state.havainnot.authentication,
                    observation: state.havainnot.observation
                }
            }
        };

        return appReducer(state, action)
    }
}

export default createRootReducer;
